import CompassEmbed, { CompassEmbedProps } from './CompassEmbed';
import { CardContext, CompassSessionUpdateKind } from '@scale/compass-shared/types';
import { CommunicationService } from '@scale/compass-ui/communicationService';
import { useCallback } from 'react';
import useExternalContext from 'react-scale/corp/views/DataCompassV2/hooks/useExternalContext';

type DataCompassWithInitialCardsProps = Omit<
  CompassEmbedProps,
  'sessionInitFn' | 'externalContext'
> & {
  initialCardContexts: CardContext[];
  autoExecuteInitialContext?: boolean;
};

export default function DataCompassWithInitialCards({
  initialCardContexts,
  compassVariant,
  autoExecuteInitialContext = false,
  hideWorkflowHeader = true,
}: DataCompassWithInitialCardsProps) {
  const externalContext = useExternalContext();

  const initializeSession = useCallback(async () => {
    const sessionState = await CommunicationService.session.start({
      compassName: compassVariant,
      externalContext,
    });
    const sessionKey = sessionState.key;

    for (const cardContext of initialCardContexts) {
      await CommunicationService.session.update(sessionKey, {
        card: cardContext,
        kind: CompassSessionUpdateKind.PUSH_CARD,
        deferExecution: !autoExecuteInitialContext,
      });
    }
    return sessionKey;
  }, [initialCardContexts, autoExecuteInitialContext, externalContext, compassVariant]);

  return (
    <CompassEmbed
      sessionInitFn={initializeSession}
      compassVariant={compassVariant}
      externalContext={externalContext}
      showHeader={true}
      hideWorkflowHeader={hideWorkflowHeader}
    />
  );
}
